<template>
  <!-- 兼容房间榜单&个人榜单 收敛逻辑 -->
  <q-section v-bind="$attrs && { ...$attrs, ...uiMeta.layout[`rankWrapperConfig${rankType + 1}`] }" p="relative">
    <ui-tabs
      :tabs="[uiMeta.images.rankTab1, uiMeta.images.rankTab2]"
      :active="rankType"
      @update:model-value="handleRankType"
      v-bind="uiMeta.layout.tabConfig" />
    <q-section :bg-i="uiMeta.images[`textBg${rankType + 1}`]" :key="`textBg${rankType + 1}`" v-bind="textRowLayerProps">
      <DaySelect v-show="rankType === 0 && enableDayRankDateSelect" v-model="rankDate" :dates="stageDates" />
    </q-section>
    <q-section :bg-i="uiMeta.images.rankDetailBg" v-bind="uiMeta.layout.rankDetailConfig" @click="toRule"></q-section>
    <Top3 v-if="!isDayRank" :top3="top3" v-bind="uiMeta.layout.top3WrapperConfig" @avatar-click="handleAvatarClick" />
    <RankList
      :listother="listother"
      v-bind="uiMeta.layout[`otherListWrapperConfig${rankType + 1}`]"
      :isDayRank="isDayRank"
      @avatar-click="handleAvatarClick"
      @room-click="handleRoomClick" />
    <RankMine
      :mineRank="mine"
      v-bind="uiMeta.layout.mineWrapperConfig"
      @click="handleClick"
      @avatar-click="handleAvatarClick" />
  </q-section>
</template>

<script setup lang="ts">
import { useRank } from './use-rank'
import { useRouter, useRoute } from 'vue-router'
import Top3 from './top3.vue'
import RankList from './rank-list.vue'
import RankMine from './rank-mine.vue'
import DaySelect from './daySelect.vue'
import { watch, computed } from 'vue'
import { setActivityBuffCards } from '@/state/activity-state'

const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => {},
  },
  buffSource: {
    type: String,
    default: '',
  },
})

const {
  mine,
  top3,
  listother,
  buffCards,
  rankType,
  handleRankType,
  handleClick,
  handleAvatarClick,
  isDayRank,
  handleRoomClick,
  enableDayRankDateSelect,
  rankDate,
  stageDates,
} = useRank(props.uiMeta, {})

// 日榜日期条与 text 行同一层：抬高 textBg，否则兄弟 RankList 后渲染会盖住下拉
const textRowLayerProps = computed(() => {
  const base = (props.uiMeta.layout?.textConfig ?? {}) as Record<string, unknown>
  if (rankType.value === 0 && enableDayRankDateSelect.value) {
    return { ...base, p: 'relative', pz: '3200' }
  }
  return { ...base }
})

const router = useRouter()
const route = useRoute()

watch(
  buffCards,
  next => {
    if (!props.buffSource) {
      return
    }
    const activityCode = (route.meta?.activity_code as any)?.toString?.() || ''
    if (!activityCode) {
      return
    }
    setActivityBuffCards(activityCode, props.buffSource as any, next)
  },
  { immediate: true }
)

const toRule = () => {
  router.push({
    path: props.uiMeta.config.detailRouter,
    query: {
      target: props.uiMeta.config.targetRuleTab,
    },
  })
}
</script>

<style scoped lang="scss"></style>
